import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IncorrectPermissions = _resolveComponent("IncorrectPermissions")!
  const _component_ValidationAlert = _resolveComponent("ValidationAlert")!
  const _component_SingleErrorMessage = _resolveComponent("SingleErrorMessage")!
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_ReportExporter = _resolveComponent("ReportExporter")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      (!_ctx.canViewRolePermission)
        ? (_openBlock(), _createBlock(_component_IncorrectPermissions, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_ValidationAlert, { "validation-results": _ctx.validationResults }, null, 8, ["validation-results"]),
            _createVNode(_component_SingleErrorMessage, { errorMessage: _ctx.error }, null, 8, ["errorMessage"]),
            (_ctx.isLoading)
              ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
              : (_openBlock(), _createBlock(_component_v_card, {
                  key: 1,
                  flat: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_toolbar, {
                      color: "secondary",
                      extended: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: "/report/metric-report",
                          custom: ""
                        }, {
                          default: _withCtx(({navigate}) => [
                            _createVNode(_component_v_btn, {
                              onClick: navigate,
                              icon: "",
                              class: "text-white"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                    _createTextVNode("mdi-arrow-left-circle", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_toolbar_title, { class: "text-white pageHeader" }, {
                          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                            _createTextVNode("Program Goal Metrics Report", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card, {
                      class: "mx-auto",
                      "max-width": "100%",
                      style: {"margin-top":"-60px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_form, {
                                  modelValue: _ctx.isValid,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isValid) = $event))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          sm: "6",
                                          md: "3"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_text_field, {
                                              modelValue: _ctx.searchDto.startDate,
                                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchDto.startDate) = $event)),
                                              label: 'Period Start Date',
                                              type: 'date',
                                              "hide-details": "",
                                              color: "white",
                                              required: "",
                                              rules: _ctx.requiredFieldRules
                                            }, null, 8, ["modelValue", "rules"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          sm: "6",
                                          md: "3"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_text_field, {
                                              modelValue: _ctx.searchDto.endDate,
                                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchDto.endDate) = $event)),
                                              label: 'Period End Date',
                                              type: 'date',
                                              "hide-details": "",
                                              color: "white",
                                              required: "",
                                              disabled: !_ctx.searchDto.startDate,
                                              rules: _ctx.endDateRules
                                            }, null, 8, ["modelValue", "disabled", "rules"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          md: "6"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_autocomplete, {
                                              modelValue: _ctx.searchDto.programIds,
                                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchDto.programIds) = $event)),
                                              items: _ctx.userAttachedPrograms,
                                              multiple: "",
                                              clearable: "",
                                              "closable-chips": "",
                                              "item-title": "description",
                                              "item-value": "treatmentProgramId",
                                              label: "Treatment Programs",
                                              disabled: !_ctx.searchDto.startDate || !_ctx.searchDto.endDate,
                                              rules: _ctx.atLeastOneRules
                                            }, null, 8, ["modelValue", "items", "disabled", "rules"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, { md: "3" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_tooltip, {
                                              location: "bottom",
                                              disabled: !_ctx.searchDto.startDate || !_ctx.searchDto.endDate
                                            }, {
                                              activator: _withCtx(({ props }) => [
                                                _createElementVNode("span", _normalizeProps(_guardReactiveProps(props)), [
                                                  _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                                    class: "mx-2 mb-4",
                                                    color: "secondary",
                                                    onClick: _ctx.selectAllPrograms,
                                                    disabled: !_ctx.searchDto.startDate || !_ctx.searchDto.endDate
                                                  }, {
                                                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                                      _createTextVNode("Select Available Programs", -1)
                                                    ]))]),
                                                    _: 1
                                                  }, 8, ["onClick", "disabled"])), [
                                                    [_directive_ripple]
                                                  ])
                                                ], 16)
                                              ]),
                                              default: _withCtx(() => [
                                                _cache[7] || (_cache[7] = _createElementVNode("span", null, "Select all available treatment programs at once.", -1))
                                              ]),
                                              _: 1
                                            }, 8, ["disabled"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"]),
                                (!_ctx.isLoadingResults)
                                  ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          align: "center",
                                          style: {"margin-bottom":"20px"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                              activator: _withCtx(({ props }) => [
                                                _createElementVNode("span", _normalizeProps(_guardReactiveProps(props)), [
                                                  _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                                    color: "info",
                                                    disabled: !_ctx.isValid && !(_ctx.reportSearch?.startDate != null && _ctx.reportSearch?.endDate != null && _ctx.reportSearch?.programIds.length > 0),
                                                    onClick: _ctx.getReportData
                                                  }, {
                                                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                                      _createTextVNode("Get Report Data", -1)
                                                    ]))]),
                                                    _: 1
                                                  }, 8, ["disabled", "onClick"])), [
                                                    [_directive_ripple]
                                                  ])
                                                ], 16)
                                              ]),
                                              default: _withCtx(() => [
                                                _createElementVNode("span", null, _toDisplayString(_ctx.getDataTooltip), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_ctx.isLoadingResults)
                          ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
                          : (_openBlock(), _createBlock(_component_v_card_text, { key: 1 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_data_table, {
                                  headers: _ctx.reportHeaders,
                                  items: _ctx.reportData,
                                  "items-per-page": -1,
                                  density: "compact",
                                  class: "elevation-1"
                                }, {
                                  "no-data": _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", {
                                        colspan: "19",
                                        class: "text-center"
                                      }, "No Data")
                                    ], -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["headers", "items"]),
                                (!_ctx.isLoadingResults && _ctx.reportData.length > 0)
                                  ? (_openBlock(), _createBlock(_component_ReportExporter, {
                                      key: 0,
                                      items: _ctx.reportData,
                                      title: "Program Metrics Report",
                                      filename: "goals-metrics-report",
                                      headers: _ctx.reportHeaders
                                    }, null, 8, ["items", "headers"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
          ]))
    ]),
    _: 1
  }))
}